import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { IoIosDocument } from 'react-icons/io'
import { get } from 'lodash'
import { formatUtcDateTime } from '../../lib/dateFormatters'
import Treeable from '../common/Treeable'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import serviceAreaActions from '../../actions/AncillaryServiceAreas'

export class AncillaryServiceAreaShow extends Component {
  static propTypes = {
    showServiceAreaAction: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    serviceArea: PropTypes.object,
    params: PropTypes.object.isRequired
  }

  componentDidMount() {
    const { showServiceAreaAction } = this.props
    showServiceAreaAction(this.id)
  }

  get defaultAttributes() {
    return { ancillary_service_area_id: this.id, rejection_reason: '' }
  }

  get id() {
    return this.props.params.id
  }

  get shouldRender() {
    return this.props.serviceArea
  }

  get documentUrl() {
    return this.props.serviceArea.document.public_url
  }

  get documentLink() {
    if (this.documentUrl) {
      return (
        <a href={this.documentUrl} target="_sbc">
          <IoIosDocument size={30} />
          Document
        </a>
      )
    }
    return 'No Document Attached'
  }

  get treeComponents() {
    return (
      this.props.serviceArea.howie_geographies.map((tree, index) => (
        <Treeable
          key={`${tree.name}_${index}`}
          name={tree.name}
          data={tree}
        />
      ))
    )
  }

  get returnPath() {
    return get(this.props.location, 'state.return_path', '/ancillary_service_areas/')
  }

  formattedDateValue = (value) => {
    return formatUtcDateTime(value)
  }

  render() {
    const { serviceArea } = this.props

    if (!this.shouldRender) return null

    return (
      <div className="content">
        <h1>Ancillary Service Area</h1>
        <div>
          {this.documentLink}
        </div>
        <h5>Metadata</h5>
        <table className="pure-table service_area_info">
          <tbody>
            <tr>
              <td><strong>External ID</strong></td>
              <td name="external_id">{serviceArea.external_id}</td>
            </tr>
            <tr>
              <td><strong>Vericred ID</strong></td>
              <td name="vericred_id">{serviceArea.vericred_id}</td>
            </tr>
            <tr>
              <td><strong>Issuer</strong></td>
              <td name="issuer_id">{serviceArea.issuer_id}</td>
            </tr>
            <tr>
              <td><strong>Line of Coverage</strong></td>
              <td name="line_of_coverage">{serviceArea.line_of_coverage}</td>
            </tr>
            <tr>
              <td><strong>Audience</strong></td>
              <td name="audience">{serviceArea.audience}</td>
            </tr>
            <tr>
              <td><strong>Last Updated At</strong></td>
              <td name="updated_at">{this.formattedDateValue(serviceArea.updated_at)}</td>
            </tr>
            <tr>
              <td><strong>Number of Geographies</strong></td>
              <td name="geography_count">{serviceArea.geography_count}</td>
            </tr>
            <tr>
              <td><strong>Number of Zip Codes</strong></td>
              <td name="zip_code_count">{serviceArea.zip_code_count}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h5>Geographies</h5>
        <div className="tree">
          {this.treeComponents}
        </div>
        <br />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const showSlice = state.ancillaryServiceAreas.show
  const configuration = state.login.session.configuration.ancillary_service_areas

  return {
    serviceArea: showSlice.attributes,
    configuration
  }
}

const mapDispatchToProps = {
  showServiceAreaAction: serviceAreaActions.show.main
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AncillaryServiceAreaShow))
